import React, { useState, useEffect, useRef } from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse } from "antd";
import Skeleton from "react-loading-skeleton";
import MapRepairPoint from "../map_infra/MapRepairPoint";

const { Panel } = Collapse;
export default function Fixed_Problem_detailMap({
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  showHeader,
  showLabel = true,
}) {
  const [Problemlist, setProblemlist] = useState([]);
  const [callApiSuccess, setcallApiSuccess] = useState(false);
  const unmounted = useRef(false);
  useEffect(() => {
    Api.post("job_detail/get_jobfixproblem_list", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_id: headerdata.job_id,
    }).then((res) => {
      if (res?.data.result?.code === "P") {
        const filterheadder = res.data.data.job_fixproblem_List
          ?.filter(
            (m) =>
              m.problem_type_name !== null ||
              m.service_cause_name !== null ||
              m.service_type_name !== null
          )
          .map((s) => ({
            problem_type_name: s.problem_type_name,
            service_cause_name: s.service_cause_name,
            service_type_name: s.service_type_name,
          }));
        setProblemlist(filterheadder);
        setcallApiSuccess(true);
      }
    });
    return () => {
      unmounted.current = true;
    };
  }, [headerdata.job_id]);
  return (
    <>
      {showHeader ? (
        <>
          <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
            <Panel
              header={
                <>
                  <h4>{"รายละเอียดบันทึกซ่อม"}</h4>
                </>
              }
              key="1"
            >
              {callApiSuccess ? (
                <div className="d-flex align-content-md-start flex-wrap w-100">
                  {Problemlist && Problemlist.length > 0 ? (
                    Problemlist.map((data, index) => (
                      <>
                        <div
                          className="col col-12"
                          key={`fixproblemmap_list_index_${index}`}
                        >
                          <div className="row">
                            {showLabel ? (
                              <span className="col-12 col-sm-4 content-label">
                                Problem Type
                              </span>
                            ) : null}
                            <span className="col-12 col-sm-8 content-text">
                              {data.problem_type_name}
                            </span>
                          </div>
                          <div className="row">
                            {showLabel ? (
                              <span className="col-12 col-sm-4 content-label">
                                Service Cause
                              </span>
                            ) : null}
                            <span className="col-12 col-sm-8 content-text">
                              {data.service_cause_name}
                            </span>
                          </div>
                          <div className="row">
                            {showLabel ? (
                              <span className="col-12 col-sm-4 content-label">
                                Service Type
                              </span>
                            ) : null}
                            <span className="col-12 col-sm-8 content-text">
                              {data.service_type_name}
                            </span>
                          </div>
                        </div>
                      </>
                    ))
                  ) : (
                    <div className="row">
                      <span className="col-12 content-text">
                        ไม่พบข้อมูลรายละเอียดบันทึกซ่อม
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                <Skeleton height={200}></Skeleton>
              )}
            </Panel>
          </Collapse>
          <Collapse ghost collapsible="disabled" defaultActiveKey={["1"]}>
            <Panel
              showArrow={false}
              header={
                <div className="font-thai-b fs-18">
                  <span className="c-blue text-uppercase">ระบุการซ่อม</span>
                </div>
              }
              key="1"
              className="font-thai-r fs-18"
            >
              <div className="row">
                <MapRepairPoint jobData={headerdata} />
              </div>
            </Panel>
          </Collapse>
        </>
      ) : callApiSuccess ? (
        <div className="d-flex align-content-md-start flex-wrap w-100">
          {Problemlist && Problemlist.length > 0 ? (
            Problemlist.map((data, index) => (
              <>
                <div
                  className="col col-12"
                  key={`Problem_list_detail_list_${index}`}
                >
                  <div className="row">
                    {showLabel ? (
                      <span className="col-12 col-sm-4 content-label">
                        Problem Type
                      </span>
                    ) : null}
                    <span className="col-12 col-sm-8 content-text">
                      {data.problem_type_name}
                    </span>
                  </div>
                  <div className="row">
                    {showLabel ? (
                      <span className="col-12 col-sm-4 content-label">
                        Service Cause
                      </span>
                    ) : null}
                    <span className="col-12 col-sm-8 content-text">
                      {data.service_cause_name}
                    </span>
                  </div>
                  <div className="row">
                    {showLabel ? (
                      <span className="col-12 col-sm-4 content-label">
                        Service Type
                      </span>
                    ) : null}
                    <span className="col-12 col-sm-8 content-text">
                      {data.service_type_name}
                    </span>
                  </div>
                </div>
              </>
            ))
          ) : (
            <div className="row">
              <span className="col-12 content-text">
                ไม่พบข้อมูลรายละเอียดบันทึกซ่อม
              </span>
            </div>
          )}
        </div>
      ) : (
        <Skeleton height={300}></Skeleton>
      )}
    </>
  );
}
